export type GlobalDatePreset =
  | 'allTime'
  | 'today'
  | 'yesterday'
  | 'last7d'
  | 'last30d'
  | 'thisWeek'
  | 'lastWeek'
  | 'thisMonth'
  | 'lastMonth'
  | 'thisQuarter'
  | 'lastQuarter'
  | 'thisYear'
  | 'lastYear'

export function toIsoDate(d: Date): string {
  return d.toISOString().slice(0, 10)
}

export function computeGlobalPresetRange(preset: GlobalDatePreset): { start: string; end: string } {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const y = today.getFullYear()
  const m = today.getMonth()

  switch (preset) {
    case 'allTime':
      return { start: '', end: '' }

    case 'today':
      return { start: toIsoDate(today), end: toIsoDate(today) }

    case 'yesterday': {
      const d = new Date(today.getTime() - 86400000)
      return { start: toIsoDate(d), end: toIsoDate(d) }
    }

    case 'last7d': {
      return { start: toIsoDate(new Date(today.getTime() - 6 * 86400000)), end: toIsoDate(today) }
    }

    case 'last30d': {
      return { start: toIsoDate(new Date(today.getTime() - 29 * 86400000)), end: toIsoDate(today) }
    }

    case 'thisWeek': {
      // ISO week: Monday = 0 offset
      const dow = today.getDay() === 0 ? 6 : today.getDay() - 1
      return { start: toIsoDate(new Date(today.getTime() - dow * 86400000)), end: toIsoDate(today) }
    }

    case 'lastWeek': {
      const dow = today.getDay() === 0 ? 6 : today.getDay() - 1
      const thisMonday = new Date(today.getTime() - dow * 86400000)
      const lastMonday = new Date(thisMonday.getTime() - 7 * 86400000)
      const lastSunday = new Date(thisMonday.getTime() - 86400000)
      return { start: toIsoDate(lastMonday), end: toIsoDate(lastSunday) }
    }

    case 'thisMonth': {
      return { start: toIsoDate(new Date(y, m, 1)), end: toIsoDate(today) }
    }

    case 'lastMonth': {
      const firstOfThisMonth = new Date(y, m, 1)
      const lastOfLastMonth = new Date(firstOfThisMonth.getTime() - 86400000)
      const firstOfLastMonth = new Date(lastOfLastMonth.getFullYear(), lastOfLastMonth.getMonth(), 1)
      return { start: toIsoDate(firstOfLastMonth), end: toIsoDate(lastOfLastMonth) }
    }

    case 'thisQuarter': {
      const quarterStart = new Date(y, Math.floor(m / 3) * 3, 1)
      return { start: toIsoDate(quarterStart), end: toIsoDate(today) }
    }

    case 'lastQuarter': {
      const thisQStartMonth = Math.floor(m / 3) * 3
      const lastQStartMonth = thisQStartMonth - 3
      const lqy = lastQStartMonth < 0 ? y - 1 : y
      const lqm = lastQStartMonth < 0 ? lastQStartMonth + 12 : lastQStartMonth
      const lastQStart = new Date(lqy, lqm, 1)
      const lastQEnd = new Date(y, thisQStartMonth, 0)
      return { start: toIsoDate(lastQStart), end: toIsoDate(lastQEnd) }
    }

    case 'thisYear': {
      return { start: toIsoDate(new Date(y, 0, 1)), end: toIsoDate(today) }
    }

    case 'lastYear': {
      return { start: toIsoDate(new Date(y - 1, 0, 1)), end: toIsoDate(new Date(y - 1, 11, 31)) }
    }
  }
}
